import React from 'react';
import { Nullable } from 'global';
import { NO_DATA } from 'constants/common';
import { Business } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';

interface Props {
  account: Nullable<string>;
}

export const AccountCell = ({ account }: Props) => (
  <Stack direction="row" alignItems="center" gap={0.5}>
    <Business fontSize="small" color="action" />

    <Typography variant="body2" noWrap>
      {account || NO_DATA}
    </Typography>
  </Stack>
);
